import { render, staticRenderFns } from "./supplier-list.vue?vue&type=template&id=6533427a"
import script from "./supplier-list.vue?vue&type=script&lang=js"
export * from "./supplier-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports